export default "__VITE_ASSET__DBijCIUB__"